// extracted by mini-css-extract-plugin
export default {"root":"ExercisesTop_root__BnZMh"};